import { CreateMeStatus } from '@spa/generated/graphql/graphql';

const isErrorStatus = (failedCause: CreateMeStatus): boolean => {
  return (
    failedCause === CreateMeStatus.EMAIL_IN_USE ||
    failedCause === CreateMeStatus.PWD_TOO_WEAK ||
    failedCause === CreateMeStatus.INVALID_EMAIL ||
    failedCause === CreateMeStatus.ACCOUNT_EXISTS_VERIFIED ||
    failedCause === CreateMeStatus.ACCOUNT_EXISTS_UNVERIFIED
  );
};

export default isErrorStatus;
